import React, { useState, useEffect } from "react";
import '../../Responsive.css'
import './Purchase_dashboard.css'

import PurchaseForm from "./New_Purchase_Request";
import All_Purchase_Requests from "./All_requests";
import { host, Host } from '../../App';
import Axios from 'axios'

const Purchase_dashboard = () => {
  const [animation, setAnimation] = useState(true);
  var userName = (window.localStorage.getItem("Name").replace(/[{""}]/g, ""));
  const [Area, setArea] = useState("");
  var Stage = (window.localStorage.getItem("Stage"));
  const [rank_stage, setrank_stage] = useState(false);
  var Ranked = (window.localStorage.getItem("Rank"));
  const [mold_list, setmold_list] = useState(false);
  const [New_Request, setNew_Request] = useState(false);
  const [All_Request, setAll_Request] = useState(false);
  const [newrequests, setnewrequests] = useState([]);
  const [awaitingorder, setawaitingorder] = useState([]);
  var token = (window.localStorage.getItem("acessToken"));

  const queryParams = {
    token: token,
  };
  useEffect(() => {
    Axios.get(`https://` + Host + `/Purchase_Requisitions/newrequests`, { params: queryParams })
      .then((data) => {
        console.log(data);
        // Ensure data.data is an array, fallback to empty array if not
        setnewrequests(Array.isArray(data.data) ? data.data : []);
      })
      .catch((error) => {
        console.error('Error fetching new requests:', error);
        setnewrequests([]); // Set to empty array on error
      });
  }, []);

  useEffect(() => {
    Axios.get(`https://` + Host + `/Purchase_Requisitions/awaitingorder`, { params: queryParams })
      .then((data) => {
        console.log(data);
        // Ensure data.data is an array, fallback to empty array if not
        setawaitingorder(Array.isArray(data.data) ? data.data : []);
      })
      .catch((error) => {
        console.error('Error fetching awaiting orders:', error);
        setawaitingorder([]); // Set to empty array on error
      });
  }, []);
  useEffect(() => {
    if (Area == "NEW PURCHASE REQUEST") {
      setmold_list(false);
      setAnimation(false);
      setAll_Request(false);
      setNew_Request(true);
    } if (Area == "ALL REQUESTS") {
      setmold_list(false);
      setAnimation(false);
      setNew_Request(false);
      setAll_Request(true);
    } if (Area == "DAILY PURCHASE REPORT") {
      setmold_list(false);
      setAnimation(false);
      setNew_Request(true);
      setAll_Request(false);
    } if (Area == "PURCHASE REPORTS") {
      setmold_list(false);
      setAnimation(false);
      setNew_Request(false);
      setAll_Request(true);
    }
  }, [Area]);
  const handleSelect = (selectedArea) => {
    setArea(selectedArea);
  };

  useEffect(() => {
    if (Ranked === '"Admin"' && Stage === '"2"') {
      setrank_stage(true);
    }
  }, [Ranked]);

  return (
    <div class="row" id="main-row">
      <div className="row header-row-production">
        <div className="col header-nav-col">
          <nav className="header-nav">
            <ul className="header-nav-list">
              <li
                className="header-nav-item"
                onClick={() => handleSelect('NEW PURCHASE REQUEST')}
              >
                New Purchase Request
              </li>
              <li
                className="header-nav-item"
                onClick={() => handleSelect('ALL REQUESTS')}
              >
                All Requests
              </li>
            </ul>
          </nav>
        </div>
      </div>


      <br />

      <h1 id="area-title" class="area-title-production">{Area}</h1>
      {animation ? (
        <div >
          <div class="row" id="area-title-overflow">
            <div class="col-1">
            </div>
            <div class="col-5" id="Purchase_dashboard">
              <h1>NEW REQUESTS</h1>
              <table className="table table-striped" id="Purchase_dashboard_table">
                <thead>
                  <tr>
                    <th>Request Date</th>
                    <th>Request By</th>
                    <th>Item Description</th>
                    <th>Qty</th>
                    <th id="mobileView">Status</th>
                  </tr>
                </thead>
                <tbody>
                  {newrequests.map((val, index) => {
                    return (

                      <tr key={val.ID} >
                        <td>{val.Requested_Date ? val.Requested_Date.slice(0, 10) : ""}</td>
                        <td>{val.Name}</td>
                        <td className="truncate-hover" title={val.Item_Desc || ""}>
                          {(() => {
                            const text = val.Item_Desc || "";
                            const urlRegex = /(https?:\/\/[^\s]+)/g;
                            const parts = text.split(urlRegex);

                            return parts.map((part, idx) => {
                              if (urlRegex.test(part)) {
                                const display = part.length > 30 ? part.slice(0, 30) + "…" : part;
                                return (
                                  <a
                                    key={idx}
                                    href={part}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{
                                      color: "#007bff",
                                      textDecoration: "underline",
                                      whiteSpace: "nowrap"
                                    }}
                                  >
                                    {display}
                                  </a>
                                );
                              }
                              return <span key={idx}>{part}</span>;
                            });
                          })()}
                        </td>
                        <td>{val.Qty}</td>

                        <td id="mobileView">{val.Status}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            <div class="col-5" id="Purchase_dashboard">
              <h1>APPROVED ORDERS</h1>
              <table className="table table-striped" id="Purchase_dashboard_table">
                <thead>
                  <tr>
                    <th>Request Date</th>
                    <th>Item Description</th>
                    <th>Qty</th>
                    <th>Required Before</th>
                    <th id="mobileView">Status</th>
                  </tr>
                </thead>
                <tbody>
                  {awaitingorder.map((val, index) => {
                    return (

                      <tr key={val.ID} >
                        <td>{val.Requested_Date ? val.Requested_Date.slice(0, 10) : ""}</td>
                        <td className="truncate-hover" title={val.Item_Desc || ""}>
                          {(() => {
                            const text = val.Item_Desc || "";
                            const urlRegex = /(https?:\/\/[^\s]+)/g;
                            const parts = text.split(urlRegex);

                            return parts.map((part, idx) => {
                              if (urlRegex.test(part)) {
                                const display = part.length > 30 ? part.slice(0, 30) + "…" : part;
                                return (
                                  <a
                                    key={idx}
                                    href={part}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{
                                      color: "#007bff",
                                      textDecoration: "underline",
                                      whiteSpace: "nowrap"
                                    }}
                                  >
                                    {display}
                                  </a>
                                );
                              }
                              return <span key={idx}>{part}</span>;
                            });
                          })()}
                        </td>
                        <td>{val.Qty}</td>
                        <td>{val.Required_Before ? val.Required_Before.slice(0, 10) : ""}</td>


                        <td id="mobileView">{val.Status}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <div class="col-1">
            </div>
          </div>
        </div>
      ) : null}
      {All_Request ? <All_Purchase_Requests /> : null}
      {New_Request ? <PurchaseForm /> : null}

    </div>

  );
}

export default Purchase_dashboard;